import { render } from "./IndividualModifier.vue?vue&type=template&id=60094297&scoped=true"
import script from "./IndividualModifier.vue?vue&type=script&lang=js"
export * from "./IndividualModifier.vue?vue&type=script&lang=js"

import "./IndividualModifier.vue?vue&type=style&index=0&id=60094297&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60094297"]])

export default __exports__